import React from 'react';
import { Loader } from '@fourthwall/components';
import { useAbandonedCheckoutRemindersSettings } from '@modules/Dashboard/pages/Settings/pages/Checkout/hooks/useAbandonedCheckoutRemindersSettings';
import { KlaviyoConnected } from './components/KlaviyoConnected';
import { KlaviyoGetStarted } from './components/KlaviyoGetStarted';
import { KlaviyoSetLists } from './components/KlaviyoSetLists';
import { KlaviyoSyncJobActive } from './components/KlaviyoSyncJobActive';
import { useKlaviyo } from './hooks/useKlaviyo';
const DEFAULT_SYNC_JOB_KEYS = [
    'MEMBERS',
    'NEWSLETTER',
    'OFFERS',
    'PROMOTIONS',
    'COLLECTIONS',
];
export const AppsKlaviyoSettings = () => {
    const { klaviyo, syncStatus, 
    // actions
    refreshLists, isRefreshing, setLists, isSettingLists, createSyncJob, isCreatingSyncJob, } = useKlaviyo();
    const { abandonedCheckoutRemindersSettings } = useAbandonedCheckoutRemindersSettings();
    const isOff = abandonedCheckoutRemindersSettings.initialValues.abandonedCheckoutEmailFrequency === 'off';
    if (!klaviyo.configuration) {
        return React.createElement(Loader, null);
    }
    // Show get started button if fetchedLists is false
    if (!klaviyo.configuration.fetchedLists || !klaviyo.configuration.lists) {
        return React.createElement(KlaviyoGetStarted, { refreshLists: refreshLists, isRefreshing: isRefreshing });
    }
    // Show list configuration if lists haven't been set
    if (!klaviyo.configuration.membersListId && !klaviyo.configuration.newsletterListId) {
        return (React.createElement(KlaviyoSetLists, { lists: klaviyo.configuration.lists, setLists: setLists, isSettingLists: isSettingLists, refreshLists: refreshLists, isRefreshing: isRefreshing, membersListId: klaviyo.configuration.membersListId, newsletterListId: klaviyo.configuration.newsletterListId }));
    }
    // Show active sync status
    if (syncStatus.active) {
        return React.createElement(KlaviyoSyncJobActive, { status: syncStatus.progress });
    }
    // Show connected state
    return (React.createElement(KlaviyoConnected, { createSyncJob: () => createSyncJob({ keys: DEFAULT_SYNC_JOB_KEYS }), isCreatingSyncJob: isCreatingSyncJob, hasSynced: syncStatus.hasSynced, recentSync: syncStatus.recent, abandonedCheckoutIsOff: isOff }));
};
